import { render, staticRenderFns } from "./OrderSummarySide.vue?vue&type=template&id=30aab7f0&"
import script from "./OrderSummarySide.vue?vue&type=script&lang=js&"
export * from "./OrderSummarySide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports